// Dependecies
import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

// component
import RedirectIndex from './components/RedirectController/RedirectIndex';
import RouterComponent from './components/RouterComponent';
import PrivateRoute from './PrivateRoute';

// User Not loggin
import Home from './views/Home';
import Register from './views/Register';
import Login from './views/Login';
import Plans from './views/Plans';
import Terms from './views/Terms';
import RecoverPassword from './views/RecoverPassword';
import NewPassword from './views/NewPassword';

// User view is LoggedIn
import CompanyDashboard from './views/Business/Dashboard';
import Profile from './views/Business/Profile';
import WorkshopDashboard from './views/WorkShops/DashboardWorkShops';
import Benefits from './views/WorkShops/Benefit';
import MaintenanceHistory from './views/WorkShops/MaintenanceHistory';
import MaintenanceSchedule from './views/WorkShops/Maintenance';
import JobsAgenda from './views/Business/Maintenance';
import QualifyService from './views/Business/QualifyService';
import JobRequests from './views/Business/JobRequests';
import Report from './views/Business/Report';
import PlansCompany from './views/Business/Plans';
import VehicleRegistration from './views/Business/VehicleRegistration';
import BenefitsCompany from './views/Business/Benefit';
import DriverRegistration from './views/Business/DriverRegistration';
import UserRegistration from './views/Business/UserRegistration';
import UserRegistrationWorkShop from './views/WorkShops/UserRegistrationWorkShop';
import InfoService from './views/Business/InfoService';
import StockStorage from './views/WorkShops/Storage';
import VehiclesView from './views/Business/VehiclesView';

function Main(props) {
  const { t } = props;

  return (
    <Switch>
      {/* User might LogIn */}
      <RedirectIndex exact path="/" />
      <RouterComponent exact path="/:lang(en|es)" componentName="Home" Component={Home} />
      <RouterComponent
        exact
        path={`/:lang(en|es)/${t('Register')}`}
        componentName="Register"
        Component={Register}
      />
      <RouterComponent
        exact
        path={`/:lang(en|es)/${t('Login')}`}
        componentName="Login"
        Component={Login}
      />
      <RouterComponent
        exact
        path={`/:lang(en|es)/${t('Plans')}`}
        componentName="Plans"
        Component={Plans}
      />
      <RouterComponent
        exact
        path={`/:lang(en|es)/${t('VerifyEmail')}/:token`}
        componentName="Login"
        component={Login}
      />
      <RouterComponent
        exact
        path={`/:lang(en|es)/${t('Terms')}/:slug`}
        componentName="Terms"
        Component={Terms}
      />
      <RouterComponent
        exact
        path={`/:lang(en|es)/${t('RecoverPassword')}`}
        componentName="RecoverPassword"
        Component={RecoverPassword}
      />
      <RouterComponent
        exact
        path={`/:lang(en|es)/${t('NewPassword')}/:token`}
        componentName="NewPassword"
        Component={NewPassword}
      />
      {/* User will LogIn */}
      <PrivateRoute
        exact
        path={`/:lang(en|es)/${t('CompanyDashboard')}`}
        componentName="CompanyDashboard"
        Component={CompanyDashboard}
      />

      <PrivateRoute
        exact
        path={`/:lang(en|es)/${t('Profile')}`}
        componentName="Profile"
        Component={Profile}
      />
      <PrivateRoute
        exact
        path={`/:lang(en|es)/${t('WorkshopDashboard')}`}
        componentName="WorkshopDashboard"
        Component={WorkshopDashboard}
      />
      <PrivateRoute
        exact
        path={`/:lang(en|es)/${t('Benefits')}`}
        componentName="Benefits"
        Component={Benefits}
      />
      <PrivateRoute
        exact
        path={`/:lang(en|es)/${t('MaintenanceSchedule')}`}
        componentName="MaintenanceSchedule"
        Component={MaintenanceSchedule}
      />
      <PrivateRoute
        exact
        path={`/:lang(en|es)/${t('MaintenanceHistory')}`}
        componentName="MaintenanceHistory"
        Component={MaintenanceHistory}
      />

      <PrivateRoute
        exact
        path={`/:lang(en|es)/${t('JobsAgenda')}`}
        componentName="JobsAgenda"
        Component={JobsAgenda}
      />

      <PrivateRoute
        exact
        path={`/:lang(en|es)/${t('JobRequests')}`}
        componentName="JobRequests"
        Component={JobRequests}
      />

      <PrivateRoute
        exact
        path={`/:lang(en|es)/${t('Report')}`}
        componentName="Report"
        Component={Report}
      />

      <PrivateRoute
        exact
        path={`/:lang(en|es)/${t('QualifyService')}`}
        componentName="QualifyService"
        Component={QualifyService}
      />

      <PrivateRoute
        exact
        path={`/:lang(en|es)/${t('DriverRegistration')}`}
        componentName="DriverRegistration"
        Component={DriverRegistration}
      />

      <PrivateRoute
        exact
        path={`/:lang(en|es)/${t('UserRegistration')}`}
        componentName="UserRegistration"
        Component={UserRegistration}
      />

      <PrivateRoute
        exact
        path={`/:lang(en|es)/${t('UserRegistrationWorkShop')}`}
        componentName="UserRegistrationWorkShop"
        Component={UserRegistrationWorkShop}
      />

      <PrivateRoute
        exact
        path={`/:lang(en|es)/${t('PlansCompany')}`}
        componentName="PlansCompany"
        Component={PlansCompany}
      />

      <PrivateRoute
        exact
        path={`/:lang(en|es)/${t('VehicleRegistration')}`}
        componentName="VehicleRegistration"
        Component={VehicleRegistration}
      />

      <PrivateRoute
        exact
        path={`/:lang(en|es)/${t('BenefitsCompany')}`}
        componentName="BenefitsCompany"
        Component={BenefitsCompany}
      />

      <PrivateRoute
        exact
        path={`/:lang(en|es)/${t('InfoService')}/:token`}
        componentName="InfoService"
        Component={InfoService}
      />
       <PrivateRoute
        exact
        path={`/:lang(en|es)/${t('StockStorage')}`}
        componentName="StockStorage"
        Component={StockStorage}
      />

      <PrivateRoute
        exact
        path={`/:lang(en|es)/${t('VehiclesView')}`}
        componentName="VehiclesView"
        Component={VehiclesView}
      />
    </Switch>
  );
}

Main.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('routers')(Main);
